import $ from "jquery";
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);


if(document.getElementById('app_product') != null){
    document.addEventListener('alpine:init', () => {
        Alpine.data('app_product', (route_product_json, formData, _config_api, modal_cta_recap, modal_portefeuille, invoice_url_json, logged) => ({
            route_product_json : null,
            product : null,
            invoice : null,
            showDesc : false,
            isRecapLoaded : false,
            cta_pay_tarif_disabled : true,
            isPaying : false,
            error_pay : false,
            error_address : false,
            tarif_recap : {
                "nom": null,
                "currency": null,
                "description": null,
                "interval": null,
                "unit_amount": null
            },
            default_pm_recap : {
                id : null
            },
            init() {
                // initialize main function
                this.route_product_json = route_product_json;
                this.formData = formData;
                this._config_api = _config_api;
                this.modal_cta_recap = modal_cta_recap;
                this.modal_portefeuille = modal_portefeuille;
                this.invoice_url_json = invoice_url_json;
                this.logged = logged;

                if(this.invoice_url_json != ''){
                    this.loadInvoice();
                }else{
                    this.invoice_url_json = null;
                    this.$watch('formData.price_id', () => {
                        this.changed();
                    })
                }
                this.loadProduct();
            },
            autoOpenModalChecker(){
                if(!this.logged){
                    sessionStorage.setItem('autoOpenPaiement', this.product.id);
                }
                if(this.logged){
                    if(sessionStorage.getItem('autoOpenPaiement') == this.product.id){
                        this.modal_cta_recap = true;
                    }
                    sessionStorage.removeItem('autoOpenPaiement');
                }
            },
            loadInvoice(){
                axios({
                    method: 'get',
                    url: this.invoice_url_json
                }).then(response =>{

                    if(!response.data){

                    }else
                    if(response.data.success){
                        this._OnInvoiceUpdateFromData(response.data);
                    }
                });
            },
            _OnInvoiceUpdateFromData(data){
                if(data.success){
                    this.$nextTick(() => {
                        try {
                            data.invoice['period_start_readable']= dayjs(data.invoice['period_start']).format('DD MMM YYYY');
                            data.invoice['period_end_readable']= dayjs(data.invoice['period_end']).format('DD MMM YYYY');
                            data.invoice['created_readable']= dayjs(data.invoice['created']).format('DD MMM YYYY');

                        } catch (error) {

                        }

                        this.invoice =  data.invoice;
                    })
                }
            },
            loadProduct(){
                axios({
                    method: 'get',
                    url: route_product_json
                }).then(response =>{

                    if(!response.data){

                    }else
                    if(response.data.success){
                        this._OnProductUpdateFromData(response.data);
                    }
                });
            },

            _OnProductUpdateFromData(data){
                if(data.success){
                    this.$nextTick(() => {
                        data.product['avantages_tab']=[];
                        if(data.product.avantages){
                            data.product['avantages_tab'] =  data.product.avantages.split(/(?:\r\n|\r|\n)/g);
                            for (let idesc = 0; idesc <  data.product['avantages_tab'].length; idesc++) {
                                if( data.product['avantages_tab'][idesc]  == ""){
                                    data.product['avantages_tab'][idesc] = false;
                                }
                            }
                        }

                        this.product =  data.product;
                        if(this.product.is_address_needed){
                            if(this.defaultAddress!= null){
                                if(this.defaultAddress.id){
                                    this.error_address = false;
                                }else{
                                    this.error_address = true;
                                }
                            }else{
                                this.error_address = true;
                            }
                        }
                        this.formData.price_id = this.product.tarifs[0].price_id;
                        //force chrome sur l history back;
                        document.getElementById('modal_cta_recap').checked = false;

                        this.autoOpenModalChecker();
                    })
                }
            },
            changed(d){
                console.log('input changed ' + formData.price_id );
                this.clear_recap();
                this.fill_recap(formData.price_id);
            },
            /**
             * Bouton fix passer au paiement
             */
            cta_passer_au_paiement(){
                console.log('cta_passer_au_paiement');
                this.modal_cta_recap = true;
                if(this.tarif_recap.nom == null){
                    this.fill_recap(formData.price_id);
                }

            },
            cta_passer_au_paiement_invoice(invoice){
                console.log('cta_passer_au_paiement_invoice');
                this.modal_cta_recap = true;
                if(this.tarif_recap.nom == null){
                    this.fill_recap_invoice();
                }

            },
            cta_cancel_passer_au_paiement(){
                if(!this.isPaying){
                    this.clear_recap();
                    this.modal_cta_recap = false;

                }

            },
            cta_pay(){
                if(this.invoice_url_json){
                    var pm = this.default_pm_recap.id;
                    var id = this.invoice.id;
                    this.payInvoice(pm, id);
                }else{
                    var pm = this.default_pm_recap.id;
                    var id = this.formData.price_id;
                    this.pay(pm, id);
                }

            },

            cta_cancel_portefeuille(){
                this.modal_portefeuille = false;
            },

            handlenewPmSuccess(){
                console.log('handlenewPmSuccess');
                if(this.invoice_url_json){
                    this.fill_recap_invoice();
                }else{
                    this.fill_recap(formData.price_id);
                }

                this.modal_cta_recap = true;
                this.modal_portefeuille = false;


            },
            defaultAddress : {},
            handlenewaddressSuccess(defaultAddress){
                this.defaultAddress = JSON.parse(JSON.stringify(defaultAddress));

                if(this.defaultAddress.id != null){
                    this.error_address = false;
                }else{
                    this.error_address = true;
                }
            },

            stripe : null,
            get_stripe : function(){
                if(this.stripe == null){
                    this.stripe = Stripe(_config_api.STRIPE_KEY, {'stripeAccount' : _config_api.account_id});
                    console.log(_config_api.account_id);
                }
                return this.stripe;
            },


            pay : function(pm, id_tarif){
                console.log("payement starting");
                this.cta_pay_tarif_disabled = true;
                this.isPaying = true;
                axios.post(_config_api.routes.pay,
                    {
                        'payment_method' : pm,
                        'id_tarif' : id_tarif
                    },{
                }).then(response =>{
                    console.log(this.get_stripe());
                    if(typeof response.data.payment_intent != "undefined"){
                        this.get_stripe().confirmCardPayment (response.data.payment_intent.client_secret).then(function(result){
                            if(typeof response.data.url_gerer != "undefined"){
                                window.location.replace(response.data.url_gerer+'#payement-success');
                            }
                        })
                    }else{
                        this.get_stripe().confirmCardPayment (response.data.latest_invoice.payment_intent.client_secret).then(function(result){
                            if(typeof response.data.url_gerer != "undefined"){
                                window.location.replace(response.data.url_gerer+'#payement-success');
                            }
                        })
                    }

                }).catch(error =>{
                    console.log(error);
                    this.isPaying = false;
                    this.cta_pay_tarif_disabled = false;
                    this.error_pay = true;
                    setTimeout(() =>{
                        this.error_pay = false;
                    }, 4000)
                });
            },

            payInvoice : function(pm, id_invoice){
                console.log("payement starting");
                this.cta_pay_tarif_disabled = true;
                this.isPaying = true;
                axios.post(_config_api.routes.pay_invoice,
                    {
                        'payment_method' : pm,
                        'id_invoice' : id_invoice
                    },{
                }).then(response =>{
                    console.log(response.data);

                    if(typeof response.data.payment_intent != "undefined"){
                        this.get_stripe().confirmCardPayment (response.data.payment_intent.client_secret).then(function(result){
                            if(typeof response.data.url_gerer != "undefined"){
                                window.location.replace(response.data.url_gerer+'#payement-success');
                            }
                        })
                    }else{
                        this.get_stripe().confirmCardPayment (response.data.latest_invoice.payment_intent.client_secret).then(function(result){
                            if(typeof response.data.url_gerer != "undefined"){
                                window.location.replace(response.data.url_gerer+'#payement-success');
                            }
                        })
                    }

                }).catch(error =>{
                    console.log(error);
                    this.isPaying = false;
                    this.cta_pay_tarif_disabled = false;
                    this.error_pay = true;
                });
            },

            clear_recap : function(){

                this.default_pm_recap = {
                    'id' : null
                }

                this.tarif_recap = {
                    "nom": null,
                    "currency": null,
                    "description": null,
                    "interval": null,
                    "unit_amount": null
                };

                this.cta_pay_tarif_disabled = true;
            },
            xhr_recap : null,
            fill_recap : function(id_tarif){

                if(this.xhr_recap != null){
                    this.xhr_recap = null;
                    return;
                }

                if(!this.logged){
                    return;
                }

                var url = _config_api.routes.recap_before_pay.replace('param_id_tarif', id_tarif);

                this.isRecapLoaded = false; // [view] gere le bouton chargement

                this.xhr_recap = axios({
                    method: 'get',
                    url: url
                }).then(resp =>{

                    if(!resp.data){

                    }else
                    if(resp.data.success){

                        console.log(resp.data);

                        this.tarif_recap = resp.data.tarif;



                        if(resp.data.default_pm != null){
                            this.default_pm_recap = resp.data.default_pm;
                            this.cta_pay_tarif_disabled = false;
                        }else{
                            this.modal_portefeuille = true;
                        }

                        this.xhr_recap = null;
                        this.isRecapLoaded = true; // [view] gere le bouton chargement

                    }else if (resp.data.success == false){

                        this.error_pay = true;
                    }
                }).catch(function (error) {
                    this.xhr_recap = null;
                    this.error_pay = true;
                });

            },
            fill_recap_invoice : function(){

                if(this.xhr_recap != null){
                    this.xhr_recap = null;
                    return;
                }

                var url = _config_api.routes.recap_before_pay_invoice;

                this.isRecapLoaded = false; // [view] gere le bouton chargement

                this.xhr_recap = axios({
                    method: 'get',
                    url: url
                }).then(resp =>{

                    if(!resp.data){

                    }else
                    if(resp.data.success){

                        console.log(resp.data);

                        this.tarif_recap = {
                            "nom": 'Reglement de votre facture',
                            "currency": this.invoice.currency,
                            "description": '',
                            "interval": null,
                            "unit_amount": this.invoice.amount_remaining
                        };



                        if(resp.data.default_pm != null){
                            this.default_pm_recap = resp.data.default_pm;
                            this.cta_pay_tarif_disabled = false;
                        }

                        this.xhr_recap = null;
                        this.isRecapLoaded = true; // [view] gere le bouton chargement

                    }else if (resp.data.success == false){

                        this.error_pay = true;
                    }
                }).catch(function (error) {
                    this.xhr_recap = null;
                    this.error_pay = true;
                });

            }
        }))
    })
}

